<template>
  <div id="txidphone" class="relativeItem">
    <!--手机验证-->
    <div class="phone" v-show="next === 0">
      <div class="inputshell flex-box">
        <span class="s1">手机号</span>
        <input type="number" placeholder="请输入手机号" maxlength="11" v-model="phone" />
      </div>
      <div class="inputshell flex-box">
        <span class="s1">图片验证码</span>
        <input type="text" placeholder="请输入图片验证码" v-model="imgcode" />
        <img :src="imgcodeurl" @click="getImgCode" />
      </div>
      <div class="inputshell flex-box">
        <span class="s1">验证码</span>
        <input type="number" placeholder="请输入验证码" v-model="yzm" />
        <span class="s2 commonBk" :class="{ disable: !getCode }" @click="gcode">{{
          codeText
        }}</span>
      </div>
    </div>

    <!--提交按钮-->
    <div class="an absoluteItem overHidden commonBk centerX" @click="bind_phone">
      <div class="allA" v-if="!click_able"></div>
      {{ an_text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "txidphone",
  components: {},
  data() {
    return {
      next: 0, //0验证手机 1验证身份证
      an_text: "绑定手机",
      info: {}, //用户信息
      click_able: false, //是否允许用户点击身份证登记确认按钮
      name: "", //姓名
      idcode: "", //身份证号码
      phone: "",
      yzm: "",
      imgcode: "", //图片验证码
      imgcodeurl: "",
      codeText: "获取验证码",
      getCode: false, //是否可以获取验证码
      is: 0, //判断是否需要提交电话还是身份好吗
    };
  },
  methods: {
    //获取个人信息
    getInfo() {
      let _this = this;
      let data = {};
      this.$jsonp(this.$apis("me"), data, (res) => {
        _this.info = res.data.data.result;
      });
    },
    //获取验证码
    gcode() {
      if (this.getCode) {
        this.getCode = false;
      } else {
        return;
      }
      let _this = this;
      let data = {
        phone: this.phone,
        code: this.imgcode.toLowerCase(),
      };
      this.$jsonp(this.$apis("code"), data, (res) => {
        if (res.data.data.status == 200) {
          _this.$tool.tip("验证码已发送");
          //发送成功
          _this.getCode = false;
          let num = 59;
          let co = setInterval(() => {
            num--;
            _this.codeText = "已发送(" + num + ")";
            if (num == 0) {
              clearInterval(co);
              _this.codeText = "发送验证码";
              _this.getCode = true;
            }
          }, 1000);
        } else {
          _this.getCode = true;
          _this.$tool.tip(res.data.data.msg);
        }
      });
    },
    /**获取图片yzm */
    getImgCode() {
      let _this = this;
      this.$jsonp(this.$apis("imgcode"), {}, (res) => {
        if (res.data.data.status == 200) {
          _this.imgcodeurl = res.data.data.data;
        } else {
          _this.$tool.tip(res.data.data.msg);
        }
      });
    },

    /**绑定手机 */
    bind_phone(){
      if (!this.click_able) {
        return false;
      }else{
        this.click_able = true;
      }
      // let _this = this;
      let data = {
        phone:this.phone,
        code:this.yzm,
        imgcode:this.imgcode
      };
      console.log(data);
      // this.$router.go(-1);
    },




    /**可以提交绑定资料的判断 */
    able_db() {
      if (
        this.$tool.checkPhone(this.phone) &&
        this.imgcode != "" &&
        this.yzm.length == 6
      ) {
        this.click_able = true;
      } else {
        this.click_able = false;
      }
    },
  },
  mounted: function () {
    this.getImgCode();
    this.$tool.setTitle("手机绑定");
  },
  watch: {
    yzm() {
      this.able_db();
    },
    phone() {
      this.able_db();
    },
    imgcode() {
      if (this.$tool.checkPhone(this.phone) && this.imgcode.length === 4) {
        this.getCode = true;
      } else {
        this.getCode = false;
      }
    },
  },
};
</script>

<style scoped>
#txidphone {
  min-height: 100vh;
}
.allA {
  background: rgba(255, 255, 255, 0.5);
}
.an {
  border-radius: 1.875rem;
  width: 13.4375rem;
  height: 2.75rem;
  line-height: 2.75rem;
  font-size: 15px;
  color: white;
  text-align: center;
  bottom: 1.25rem;
}
.margin-b {
  margin-bottom: 1px;
}

/**手机验证 */
.inputshell {
  padding: 0.5rem 0.6rem;
  align-items: center;
  background: white;
  margin-bottom: 1px;
}
.inputshell .s1 {
  width: 25%;
  font-size: 15px;
}
.inputshell input {
  width: 42%;
  font-size: 15px;
  color: #333;
  height: 2.125rem;
  line-height: 2.125rem;
}
::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ccc;
}
.inputshell .s2,
.inputshell img {
  width: 7.5rem;
  height: 2.125rem;
}
.inputshell .s2 {
  line-height: 2.125rem;
  text-align: center;
  font-size: 14px;
  color: white;
  border-radius: 0.5rem;
}
.inputshell .disable {
  background: #e5e5e5;
}

/**身份验证 */
.idcodeshell p {
  font-size: 14px;
  text-align: justify;
  padding: 0.8rem;
}
.imgshell {
  padding: 1rem 0.8rem;
  justify-content: space-between;
  align-items: center;
}
.imgshell .s1,
.imgshell i {
  font-style: normal;
  font-style: 15px;
  color: #df71e1;
}
</style>
